module.exports = __webpack_public_path__ + "img/home.55061fa4.png";